import { FC, useEffect, useRef, useState } from 'react';
import { ChatMessage } from './chat-message';
import { DownOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { debounce } from 'lodash';

interface ChatMessagesProps {
  data: any;
  isAdmin: boolean;
  transactions?: any;
  userInitials: string;
}

export const ChatMessages: FC<ChatMessagesProps> = (props) => {
  const [display, setDisplay] = useState<boolean>(false);
  const divRef = useRef<HTMLDivElement>(null);

  const handleScroll = debounce(() => {
    if (divRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = divRef.current;
      if (scrollHeight - scrollTop - clientHeight > 100) {
        setDisplay(true);
      } else {
        setDisplay(false);
      }
    }
  }, 50);

  const scrollToBottom = () => {
    const div = divRef.current;
    if (div) {
      div.scrollTop = div.scrollHeight;
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [props.data]);

  return (
    <div
      style={{
        gridColumn: 1,
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'scroll',
        borderRadius: '8px',
        padding: 10,
        position: 'relative',
        height: "400px"
      }}
      ref={divRef}
      onScroll={handleScroll}
    >
      {props?.data?.map((message: any) => (
        <ChatMessage
          key={message.id}
          sentBy={message.sentBy}
          message={message.message}
          embedding={message.embedding}
          createdAt={message.createdAt}
          isAdmin={props.isAdmin}
          transactions={props.transactions}
          userInitials={props.userInitials}
        />
      ))}
      {display && (
        <Button
          onClick={scrollToBottom}
          size={'small'}
          style={{
            position: 'absolute',
            top: 10,
            left: 10,
            borderRadius: '8px',
            color: 'black',
            background: '#D3D3D380'
          }}
        >
          Return to Bottom
          <DownOutlined />
        </Button>
      )}
      <div id="bottom"></div>
    </div>
  );
};
